import { getData } from 'api/requests/GET_CHAPTER_CONTENT';

import { getQueryKey } from 'helpers/getQueryKey';

type Params = { id: string; chapterId?: string };

export const getChapterContentOptions = (params: Params) => {
  const resource = [params.id];

  if (params?.chapterId !== undefined) {
    resource.push(params.chapterId);
  }

  return {
    queryKey: getQueryKey('CHAPTER_CONTENT', resource),
    queryFn: () => {
      return getData(params.id, params?.chapterId);
    },
  };
};
